import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'
import { appAllGetFundrasing } from '../../store/fundrasing'
import { paymentHistoryExportColumns } from '../../config/exportColumns/paymentHistoryExportColumns'

function PaymentHistory() {
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Payment History</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetFundrasing({
									...params,
									...exportFilters,
									page: 1,
									limit: 100000,
									hub: hubId || permissionOfHub,
									loading: false,
								}),
							)
						}
						columns={paymentHistoryExportColumns}
						fileName="Payment_History"
						sheetName="Payment History"
						buttonText="Export Payment History"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default PaymentHistory
